import { Grid, Label, Lockup } from '@superhi/design'

import { Wrapper, Content, Color } from './styles'

type Props = Pick<React.ComponentProps<typeof Lockup>, 'subtitle' | 'subtitleRichText'> & {
  backgroundColor: Color
  title: string
  label?: string
}

const PageHeader: React.FC<Props> = ({ label, backgroundColor, ...props }) => (
  <Wrapper $backgroundColor={backgroundColor}>
    <Grid>
      <Grid.Cell span="full">
        <Content>
          {label && <Label color="GREY_70">{label}</Label>}
          <Lockup {...props} subtitleMaxWidth={36} align="center" />
        </Content>
      </Grid.Cell>
    </Grid>
  </Wrapper>
)

export default PageHeader
